export enum Indices {
  "Content" = "100",
  "Popup" = "200",
  "Modal" = "300",
}
